<template>
    <div id="paintlist-line-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="
                    () => $router.push('/optimizedpaintlistview/' + idParam)
                "
                icon="arrow-left"
                :label="trans('pages.paintlist_line.back_to_paint_order')" />
        </actions-menu>
        <pre v-if="isDebug" class="debug">{{ grouped }}</pre>
        <loader v-if="loading" />
        <template v-else>
            <div class="productdefaultfields" v-if="record">
                <div class="productpagefield">
                    <div id="productsawdetailscode">
                        {{ trans('pages.paintlist_line.profile') }} {{ record.code }}
                    </div>
                </div>
                <div class="productpagefield">
                    <div id="productsawdetailslength">
                        {{ trans('pages.paintlist_line.length') }} {{ record.length }}mm
                    </div>
                </div>
                <div class="productpagefield">
                    <div id="productsawdetailscount">
                        {{ trans('pages.paintlist_line.count') }} {{ record.count }}
                    </div>
                </div>
                <p id="productsawdetailsnote">
                    {{ trans('pages.paintlist_line.description') }} {{ record.description }}
                </p>
                <p id="productsawdetailsproducts">
                    {{ trans('pages.paintlist_line.products') }}
                    <template v-for="(product, index) in record.products">
                        <a @click="goToProductPage(product.id)">
                            {{ product.nr }}
                        </a>
                        <template v-if="index < record.products.length - 1">
                            ,
                        </template>
                    </template>
                </p>
            </div>
            <div id="paintlist-sawn" v-if="isPaintlistSawn">
                <h2>{{ trans('pages.paintlist_line.paint_order_sawn') }}</h2>
            </div>
            <div>
                <template v-for="group in grouped">
                    <template v-for="firstField in group.slice(0, 1)">
                        <div class="group-title">{{ firstField.title }}</div>
                        <div class="group">
                            <template v-for="(field, index) in group">
                                <div
                                    :style="{ color: field.hexColor }"
                                    class="field">
                                    <img :src="field.imageSrc" />
                                    <ui5-checkbox
                                        :checked="field.sawn == 1"
                                        @change="
                                            updateSawnForSawline(
                                                field,
                                                $event.target
                                            )
                                        " />
                                    <span class="key">
                                        {{ field.name }} - {{ field.productNr }}
                                    </span>
                                    <span class="value">{{ field.value }}</span>
                                </div>
                            </template>
                        </div>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>
<script>
import IdParamMixin from '../mixins/id-param';
import IsDebugMixin from '../mixins/is-debug';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import sawlistApi from '../api/sawlist';
import Loader from '../components/loader/Loader';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    mixins: [
        IdParamMixin('idParam', 'recordIdParam'),
        IsDebugMixin,
        NavigationFunctionsMixin,
        localization,
    ],
    components: { Loader, ActionsMenu, ActionsMenuItem },
    computed: {
        recordIdParam() {
            return this.$route.params.recordId;
        },
        grouped() {
            const grouped = {};
            if (this.record && this.record.sawlist) {
                this.record.sawlist.forEach((field) => {
                    if (!grouped[field.groupId]) {
                        grouped[field.groupId] = [];
                    }
                    const group = grouped[field.groupId];
                    group.push(field);
                });
            }
            return grouped;
        },
        isPaintlistSawn() {
            if (!this.record) {
                return false;
            }
            return this.record.sawlist.every((x) => x.sawn == 1);
        },
    },
    mounted() {
        this.load();
    },
    data() {
        return {
            loading: false,
            record: null,
        };
    },
    methods: {
        load() {
            this.loading = true;
            this.$store.commit(
                'general/setPageTitle',
                `${this.trans('pages.paintlist_line.paint_order_line_number')} ${this.idParam}`,
                { root: true }
            );
            sawlistApi
                .fetchSawlinesForPaintlistrecord(this.recordIdParam)
                .then((response) => {
                    const record = response.data.data;
                    record.products = [];
                    record.sawlist.forEach((sawline) => {
                        sawline.imageSrc =
                            Config.url +
                            '/profile/fetchImage/?profileId=' +
                            sawline.profile +
                            '&random=' +
                            Math.random();
                        if (
                            !record.products.includes(
                                (x) => x.productId == sawline.productId
                            )
                        ) {
                            record.products.push({
                                id: sawline.productId,
                                nr: sawline.productNr,
                            });
                        }
                    });
                    this.record = record;
                    if (this.isPaintlistSawn) {
                        window.scrollTo(0, 0);
                    }
                })
                .catch(() => {
                    showErrorMessage(this.trans('pages.paintlist_line.load_paint_order_line_error'));
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        updateSawnForSawline(sawline, checkbox) {
            sawline.sawn = checkbox.checked ? '1' : '0';
            checkbox.disabled = true;
            sawlistApi
                .updateSawnForSawline(
                    sawline.paintlistRecordSawlineId,
                    sawline.sawn
                )
                .then(() => {
                    if (this.isPaintlistSawn) {
                        window.scrollTo(0, 0);
                    }
                })
                .catch(() => {
                    sawline.sawn = sawline.sawn ? '0' : '1';
                    showErrorMessage(this.trans('pages.paintlist_line.update_sawn_status_error'));
                })
                .finally(() => {
                    checkbox.disabled = false;
                });
        },
    },
};
</script>
